import React, {useState} from 'react';
import {Form, Grid, Input} from "semantic-ui-react";
import CityInput from "../../../components/CityInput";
import ConfirmModal from "../../../components/Modals/ConfirmModal";
import SelectPointModal from "./selectPointModal";
import SectionForm from "./sectionForm";
import {stringToAddress} from "./functions/addresses";
import Info from "../../../components/Info";
import InputDropdown from "../../../components/Dropdowns/InputDropdown";

const PointSection = ({icon, label, form, changeParams, name, companyId, errors, isCreate, onChangeAddress}) => {
    const isRu = () => (form[`${name}Address`] || {}).countryCode === 'RU';
    const [isOpenAddressBookModal, setIsOpenAddressBookModal] = useState(false);
    const [isOpenStringAddressModal, setIsOpenStringAddressModal] = useState(false);
    const [postalCodeIdDisabled, setPostalCodeIsDisabled] = useState(isRu() && !!(form[`${name}Address`] || {}).postalCode);
    const [stringAddress, setStringAddress] = useState('');

    const changeCity = (nameParam, value, values = {}) => {
        const params = {
            [`${name}Address`]: {
                ...(form[`${name}Address`] || {}),
                ...values,
                [nameParam.includes('AddressCountry') ? 'countryCode' : nameParam]: value,
                id: null
            }
        }
        setPostalCodeIsDisabled(isRu() ? (nameParam !== 'postalCode' && params[`${name}Address`].postalCode) : false);
        changeParams(params);
    }

    const errorText = 'Адрес отправления не найден. Пожалуйста, внесите корректировки';

    return (
        <SectionForm
            actions={isCreate && <div className='total__change-btn'>
                <div className='total__change-btn_name' onClick={() => setIsOpenAddressBookModal(true)}>Из адресной
                    книги
                </div>
                <div className='total__change-btn_name' onClick={() => setIsOpenStringAddressModal(true)}>Адрес одной
                    строкой
                </div>
            </div>}
            icon={icon}
            label={label}
        >
            <Form className={isCreate ? '' : 'point-view'}>
                <Grid>
                    <Grid.Row columns={16}>
                        <Grid.Column width={4}>
                            <Form.Field className={errors[`${name}Address.city`] ? 'error-style' : ''}>
                                <label>
                                    Населенный пункт*
                                </label>
                                <CityInput
                                    isDisabled={!isCreate}
                                    name={name}
                                    value={form}
                                    onChange={(e, {name, value}, values) => changeCity(name, value, values)}
                                />
                            </Form.Field>
                        </Grid.Column>
                        <Grid.Column width={6}>
                            <Form.Field error={errors[`${name}Address.street`]}>
                                <label>
                                    Улица
                                </label>
                                <InputDropdown
                                    name={'street'}
                                    url={'parcels/addresses/streetAddressSuggestions'}
                                    disabled={!isCreate}
                                    value={(form[`${name}Address`] || {}).street || ''}
                                    onChange={changeCity}
                                    params={form[`${name}Address`]}
                                    paramsForSearchFields={[['city', 'cityName'], ['countryCode']]}
                                    dependentFields={['house', 'postalCode']}
                                    searchErrorText={errorText}
                                />
                            </Form.Field>
                        </Grid.Column>
                        <Grid.Column width={2}>
                            <Form.Field error={errors[`${name}Address.house`]}>
                                <label>
                                    Дом, корпус
                                </label>
                                <InputDropdown
                                    name={'house'}
                                    nameOption={'fullHouseAddress'}
                                    url={'parcels/addresses/houseAddressSuggestions'}
                                    disabled={!isCreate}
                                    value={(form[`${name}Address`] || {}).fullHouseAddress || ''}
                                    onChange={changeCity}
                                    params={form[`${name}Address`]}
                                    ignoredFields={['city', 'street']}
                                    paramsForSearchFields={[['city', 'cityName'], ['countryCode'], ['street', 'streetName']]}
                                    searchErrorText={errorText}
                                />
                            </Form.Field>
                        </Grid.Column>
                        <Grid.Column width={2}>
                            <Form.Field error={errors[`${name}Address.office`]}>
                                <label>
                                    Квартира/офис
                                </label>
                                <Input
                                    disabled={!isCreate}
                                    value={(form[`${name}Address`] || {}).office || ''}
                                    onChange={(e, {value}) => changeCity('office', value)}
                                />
                            </Form.Field>
                        </Grid.Column>
                        <Grid.Column width={2}>
                            <Form.Field error={errors[`${name}Address.postalCode`]}>
                                <label>
                                    Индекс
                                </label>
                                <Input
                                    disabled={!isCreate || postalCodeIdDisabled}
                                    value={(form[`${name}Address`] || {}).postalCode || ''}
                                    onChange={(e, {value}) => changeCity('postalCode', value)}
                                />
                            </Form.Field>
                        </Grid.Column>
                    </Grid.Row>

                    <Grid.Row columns={16}>
                        <Grid.Column width={16}>
                            <Form.Field error={errors[`${name}AddressComment`]} className='border-bottom'>
                                <label>
                                    Комментарий к адресу
                                </label>
                                <Input
                                    disabled={!isCreate}
                                    placeholder={'Этаж, подъезд, часы работы или другая информация'}
                                    value={form[`${name}AddressComment`] || ''}
                                    onChange={(e, {value}) => changeParams({
                                        [`${name}AddressComment`]: value
                                    })}
                                />
                            </Form.Field>
                        </Grid.Column>
                    </Grid.Row>

                    <Grid.Row columns={16}>
                        <Grid.Column width={5}>
                            <Form.Field error={errors[`${name}ContactPersonName`]}>
                                <label>
                                    Контактное лицо*
                                </label>
                                <Input
                                    disabled={!isCreate}
                                    value={form[`${name}ContactPersonName`] || ''}
                                    onChange={(e, {value}) => changeParams({
                                        [`${name}ContactPersonName`]: value
                                    })}
                                />
                            </Form.Field>
                        </Grid.Column>
                        <Grid.Column width={5}>
                            <Form.Field error={errors[`${name}Company`]}>
                                <label>
                                    Компания
                                    {(name !== 'shipment' && form.selectedTariff && form.selectedTariff.isRecipientCompanyRequired) ?
                                        <span>
                                            *
                                           <Info
                                               className={'m-l-5'}
                                               name={'Компания'}
                                               text={'Это поле является обязательным по условиям ТК'}
                                           />
                                        </span>
                                        : ''}
                                </label>
                                <Input
                                    disabled={!isCreate}
                                    value={form[`${name}Company`] || ''}
                                    onChange={(e, {value}) => changeParams({
                                        [`${name}Company`]: value
                                    })}
                                />
                            </Form.Field>
                        </Grid.Column>
                        <Grid.Column width={3}>
                            <Form.Field error={errors[`${name}PhoneNumber`]}>
                                <label>
                                    Телефон*
                                </label>
                                <Input
                                    disabled={!isCreate}
                                    placeholder={''}
                                    value={form[`${name}PhoneNumber`] || ''}
                                    onChange={(e, {value}) => changeParams({
                                        [`${name}PhoneNumber`]: value
                                    })}
                                    maxLength={25}
                                />
                            </Form.Field>
                        </Grid.Column>
                        <Grid.Column width={3}>
                            <Form.Field error={errors[`${name}Additional`]}>
                                <label>
                                    Добавочный
                                </label>
                                <Input
                                    disabled={!isCreate}
                                    value={form[`${name}Additional`] || ''}
                                    onChange={(e, {value}) => changeParams({
                                        [`${name}Additional`]: value
                                    })}
                                />
                            </Form.Field>
                        </Grid.Column>
                    </Grid.Row>
                </Grid>
            </Form>

            <ConfirmModal
                label={'Адрес одной строкой'}
                onConfirm={() => stringToAddress(stringAddress, setStringAddress, (data) => changeParams({
                    [`${name}Address`]: data
                }))}
                open={isOpenStringAddressModal}
                setOpen={setIsOpenStringAddressModal}
            >
                <Form>
                    <Grid>
                        <Grid.Row columns={16}>
                            <Grid.Column width={16}>
                                <Form.Field>
                                    <label>
                                        Адрес
                                    </label>
                                    <Input
                                        placeholder={'Введите или скопируйте адрес одной строкой'}
                                        value={stringAddress || ''}
                                        onChange={(e, {value}) => setStringAddress(value)}
                                    />
                                </Form.Field>
                            </Grid.Column>
                        </Grid.Row>
                    </Grid>
                </Form>
            </ConfirmModal>

            <SelectPointModal
                label={'Мои адреса'}
                open={isOpenAddressBookModal}
                setOpen={setIsOpenAddressBookModal}
                companyId={companyId}
                setPoint={(e, {value}) => onChangeAddress(name, value, true)}
            />
        </SectionForm>
    );
}

export default PointSection;


// WEBPACK FOOTER //
// ./App/pages/parcels/form_v3/pointSection.jsx